// extracted by mini-css-extract-plugin
module.exports =  {"show-more-less-button":"LDS7Mda","showMoreLessButton":"LDS7Mda"};